import type { AxiosInstance } from 'axios';
import type { ServiceResultT } from '../types/common/ServiceResultT';
import type { ServiceResult } from '../types/common/ServiceResult';
import type { SecondaryCategoryViewModel, SecondaryCategoryCreateModel, SecondaryCategoryUpdateModel } from '../types/secondary-category';
import { apiClient } from '../client/client';

export interface SecondaryCategoryQuery {
  topCategoryId?: number | null;
  isDeleted?: boolean;
  pagination?: { pageSize?: number; pageNumber?: number };
}

export class SecondaryCategoryService {
  private static readonly BASE = '/api/secondary-category';

  constructor(private readonly client: AxiosInstance = apiClient) {}

  async getAll(query?: SecondaryCategoryQuery): Promise<ServiceResultT<SecondaryCategoryViewModel[]>> {
    const params: Record<string, number | boolean> = {};
    if (query?.topCategoryId != null) params.TopCategoryId = query.topCategoryId;
    if (query?.isDeleted != null) params.IsDeleted = query.isDeleted;
    if (query?.pagination?.pageSize != null) params.PageSize = query.pagination.pageSize;
    if (query?.pagination?.pageNumber != null) params.PageNumber = query.pagination.pageNumber;
    const { data } = await this.client.get<ServiceResultT<SecondaryCategoryViewModel[]>>(
      SecondaryCategoryService.BASE,
      { params: Object.keys(params).length ? params : undefined }
    );
    return data;
  }

  async getById(id: number | string): Promise<ServiceResultT<SecondaryCategoryViewModel>> {
    const { data } = await this.client.get<ServiceResultT<SecondaryCategoryViewModel>>(
      `${SecondaryCategoryService.BASE}/${id}`
    );
    return data;
  }

  async create(payload: SecondaryCategoryCreateModel): Promise<ServiceResultT<SecondaryCategoryViewModel>> {
    const { data } = await this.client.post<ServiceResultT<SecondaryCategoryViewModel>>(
      SecondaryCategoryService.BASE,
      payload
    );
    return data;
  }

  async update(id: number | string, payload: SecondaryCategoryUpdateModel): Promise<ServiceResultT<SecondaryCategoryViewModel>> {
    const { data } = await this.client.put<ServiceResultT<SecondaryCategoryViewModel>>(
      `${SecondaryCategoryService.BASE}/${id}`,
      payload
    );
    return data;
  }

  async delete(id: number | string): Promise<ServiceResult> {
    const { data } = await this.client.delete<ServiceResult>(`${SecondaryCategoryService.BASE}/${id}`);
    return data;
  }
}

export const secondaryCategoryService = new SecondaryCategoryService();
